"use client";

import React from "react";
import { useTranslations } from "next-intl";

const HeroMyAccount = () => {
  const t = useTranslations("myOrders");
  const heroImage = "/images/my-account/my-account-hero.png";

  return (
    <div className="md:bg-[#FFFBEE] p-3 md:p-12 md:max-h-[343px] text-dark font-inter">
      <div className="flex flex-col md:flex-row items-center md:items-start md:gap-[58px] max-w-[833px] mx-auto">
        <h1 className="text-[36px]  md:hidden font-bold ">{t("title")}</h1>
        <div className="w-[193px] h-[193px]  mt-4 md:mt-0 hidden md:block">
        <img
          src={heroImage}
          alt="Book with tea"
          className="w-full h-full rounded-[4px] "
        />
        </div>

        <div className="flex-1 flex-col  hidden md:flex h-[193px]">
          <h1 className=" text-[46px] leading-none font-semibold ">{t("title")}</h1>
          <p className="text-[18px] md:mt-2 flex-1 content-center">{t("description")}</p>
        </div>
      </div>
    </div>
  );
};

export default HeroMyAccount;
